var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messageS"},[_c('el-badge',{staticClass:"item",attrs:{"value":_vm.computedData}},[_c('div',{staticClass:"msgBack"},[_c('img',{staticClass:"xiaoxi-icon",class:{ 'rotate': _vm.data?true:false },staticStyle:{"width":"100px","height":"auto"},attrs:{"src":require("@/assets/img/messLing.svg")}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }